import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCListDataComponent = class UiCListDataComponent {
};
__decorate([
    Input()
], UiCListDataComponent.prototype, "elements", void 0);
__decorate([
    Input()
], UiCListDataComponent.prototype, "backgroud", void 0);
__decorate([
    Input()
], UiCListDataComponent.prototype, "position", void 0);
UiCListDataComponent = __decorate([
    Component({
        selector: 'ui-c-list-data',
        template: "<div>\n  <ion-grid class=\"pb-0 pt-0\" [ngClass]=\"backgroud === true ? 'backgroud ion-padding' : 'ion-padding'\">\n    <ion-row *ngFor=\"let el of elements\">\n      <ion-col *ngIf=\"!!el\" [size]=\"position === 'bottom' ? 12 : 6\">\n        <ion-text class=\"ion-text-left\">\n          <span class=\"font-weight-bold\">{{ el.name | wlpTranslate}}</span><br>\n          <div *ngIf=\"position === 'bottom'\">\n            {{ el.value }}\n          </div>\n        </ion-text>\n      </ion-col>\n      <ion-col size=\"6\" class=\"text-right\" *ngIf=\"position === 'right' || position === null || position === undefined && !!el\">\n        <ion-text>\n          <div>\n            {{ el.value }}\n          </div>\n        </ion-text>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</div>\n",
        styles: [".backgroud{background-color:var(--ui-t-color-medium)!important}"]
    })
], UiCListDataComponent);

let UiCListDataModule = class UiCListDataModule {
};
UiCListDataModule = __decorate([
    NgModule({
        declarations: [UiCListDataComponent],
        imports: [
            CommonModule,
            IonicModule,
            UiBsTranslateModule
        ],
        exports: [
            UiCListDataComponent
        ]
    })
], UiCListDataModule);

/*
 * Public API Surface of ui-c-list-data
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCListDataComponent, UiCListDataModule };
//# sourceMappingURL=wlp-ui-c-list-data.js.map
